import React from 'react';
import { clientInvoices } from '../../../mocks/client';
import { formatCurrency } from '../../../lib/formatters/currency';

/**
 * Invoice history (T9.5). Download is the only per-row action — amounts and
 * status come from billing, not from the client (no-config guarantee).
 */
function InvoiceTable() {
  return (
    <div className="portal-table-wrap">
      <table className="portal-table">
        <thead>
          <tr>
            <th scope="col">Invoice</th>
            <th scope="col">Period</th>
            <th scope="col">Issued</th>
            <th scope="col">Amount</th>
            <th scope="col">Status</th>
            <th scope="col"><span className="sr-only">Actions</span></th>
          </tr>
        </thead>
        <tbody>
          {clientInvoices.map((invoice) => (
            <tr key={invoice.id}>
              <td className="portal-mono">{invoice.id}</td>
              <td>{invoice.period}</td>
              <td>{invoice.issuedOn}</td>
              <td>{formatCurrency(invoice.amount)}</td>
              <td><span className={`portal-pill pill-${invoice.status}`}>{invoice.status}</span></td>
              <td className="portal-cell-action">
                {invoice.status === 'paid' ? (
                  <button className="portal-link-button" type="button">Download PDF</button>
                ) : (
                  <span className="portal-muted">—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default InvoiceTable;
